export default __webpack_public_path__ + "static/media/APACHE RTR 180 2V_2.69de79f0.webp";